import { render, staticRenderFns } from "./RecruitingHome.vue?vue&type=template&id=55ca86c0"
import script from "./RecruitingHome.vue?vue&type=script&lang=js"
export * from "./RecruitingHome.vue?vue&type=script&lang=js"
import style0 from "./RecruitingHome.vue?vue&type=style&index=0&id=55ca86c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports